<template>
  <div class="small-form-grid">
    <div class="grid-x grid-padding-x">
      <div class="cell large-12">
        <ul class="table-overlay-menu">
          <li><a href="javascript:;" @click="openObjekt()"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-object"></use></svg> <span>Vis objekt</span></a></li>
          <li><a :href="sellerLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-seller"></use></svg> <span>Vis selger</span></a></li>

          <li v-if="objekt.mottaker"><a :href="buyerLink"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-buyer"></use></svg> <span>Vis kjøper</span></a></li>
          <li v-else class="disabled"><a href="javascript:;"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-buyer"></use></svg> <span>Vis kjøper</span></a></li>

          <li><a href="javascript:;" @click="openObjekt('kjoper')"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-invoice"></use></svg> <span>Fakturer objekt</span></a></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSidebarObjectLinks',
  props: {
    objekt: {
      type: Object,
      required: false,
      default: null
    }
  },
  computed: {
    sellerLink: function () {
      if (this.objekt.innlevav) {
        return '/kunde/' + this.objekt.innlevav.Kundenr
      } else if (this.objekt.kontrakt) {
        return '/kunde/' + this.objekt.kontrakt.Kundenr
      }

      return 'javascript:;'
    },
    buyerLink: function () {
      if (this.objekt.mottaker) {
        return '/kunde/' + this.objekt.mottaker.Kundenr
      }

      return 'javascript:;'
    }
  },
  methods: {
    openObjekt: function (toTab = false) {
      if (toTab) {
        sessionStorage.showObjektTab = toTab
      }

      this.loadObjektModal(this.objekt.Objektid)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/TheSidebarObjectLinks.vue